import Phase1HistoryPage from "./page";
export default Phase1HistoryPage;